export default {"src":"/_next/static/media/book-a-demo.5346407b.svg","height":16,"width":16};